import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../libs/core/axios-base-query";


export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: axiosBaseQuery({ 
    baseUrl: "https://tanaapi.pixeladdis.com/api"
    // baseUrl: "http://192.168.239.115:8000/api"
    }),
  tagTypes: [
    "User",
    "AwardAreas",
    "Awards",
    "Blogs",
    "Teams",
    "Units",
    "Subscribers",
    "Testimonials",
    "Partners",
    "dashboardSummary",
    "Messages",
    "Newsletter",
    "awardDetail",
    "Galleries",
    "galleryDetail"
  ],
  endpoints: () => ({}),
});
